import { render, staticRenderFns } from "./add-nimei-program.vue?vue&type=template&id=7778f932&scoped=true"
import script from "./add-nimei-program.vue?vue&type=script&lang=js"
export * from "./add-nimei-program.vue?vue&type=script&lang=js"
import style0 from "./add-nimei-program.vue?vue&type=style&index=0&id=7778f932&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7778f932",
  null
  
)

export default component.exports